import { render, staticRenderFns } from "./MyColorPicker3.vue?vue&type=template&id=566b8ecf&scoped=true&"
import script from "./MyColorPicker3.vue?vue&type=script&lang=js&"
export * from "./MyColorPicker3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b8ecf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566b8ecf')) {
      api.createRecord('566b8ecf', component.options)
    } else {
      api.reload('566b8ecf', component.options)
    }
    module.hot.accept("./MyColorPicker3.vue?vue&type=template&id=566b8ecf&scoped=true&", function () {
      api.rerender('566b8ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyColorPicker3.vue"
export default component.exports